import React, { useContext, useState } from 'react';
import loadable from '@loadable/component';
import Animation from 'ls-common-client/dist/components/Animation';
import DialogForm from '../../../components/DialogForm';
import FullScreenLoader from '../../../components/FullScreenLoader';
import { Context } from '../../../context/AppContext';
import reviewSubmitted from '../../../animations/tick.json';

const Form = loadable(() => import('./ReviewUpdateForm'), {
  fallback: <FullScreenLoader />,
});

const ReviewUpdate = ({
  showDialog,
  setShowDialog,
  review,
  updateReviewCache,
}) => {
  const {
    media: { mobile },
  } = useContext(Context);

  const [slideInShow, setSlideInShow] = useState(false);

  return (
    <>
      <DialogForm
        show={showDialog}
        name="reviewFormUpdate"
        clickOutside
        onDialogFormClose={() => setShowDialog(false)}
        notificationSlider={{
          icon: (
            <Animation
              data={reviewSubmitted}
              height={mobile ? '150px' : '100px'}
              width={mobile ? '150px' : '100px'}
            />
          ),
          heading: 'Thanks for your review!',
          text: (
            <>
              <p>
                Keep an eye on your inbox over the next 1 to 2 business days to
                see when your review goes live.
              </p>
            </>
          ),
          button: 'Return',
          buttonProps: {
            onClick: () => setSlideInShow(false),
            width: '161px',
          },
          show: slideInShow,
          onClose: () => setSlideInShow(false),
        }}
      >
        <Form
          review={review}
          slideInShow={slideInShow}
          setSlideInShow={setSlideInShow}
          setShow={setShowDialog}
          updateReviewCache={updateReviewCache}
        />
      </DialogForm>
    </>
  );
};

export default ReviewUpdate;
